/**
 * Grab the value of the given key from both objects and pass them to the given function.
 * @param x First object.
 * @param y Second object.
 * @param k Key to extract from both objects (must be the name of a property that exists on the type of both objects).
 * @param fn Function to apply to the extracted values.
 * @returns The result of applying the function to the extracted values.
 */
export function forBoth<X, Y, K extends keyof X & keyof Y, Z>(x: X, y: Y, k: K, fn: (x: X[K], y: Y[K]) => Z): Z {
    return fn(x[k], y[k]);
}
